import { render, staticRenderFns } from "./CreateKlaimCCPd.vue?vue&type=template&id=7740477a&scoped=true&"
import script from "./CreateKlaimCCPd.vue?vue&type=script&lang=js&"
export * from "./CreateKlaimCCPd.vue?vue&type=script&lang=js&"
import style0 from "./CreateKlaimCCPd.vue?vue&type=style&index=0&id=7740477a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7740477a",
  null
  
)

export default component.exports